/**
 * Tùy chỉnh mẫu
 * NMDUC1 30/10/2023
 */
export default {
    Target_Span: `<span class="target-item" contenteditable="false">{0}</span>`,
    Target_SpanGuid: `{0}<span class="target-item" contenteditable="false">{1}</span>{0}`,
    Target_Text: `{={0}}`,
    Target_TextGuid: `{0}{={1}}{0}`
}